

<div class="gap100"></div>
<div class="container container-login">
  <div class="gap80"></div>
  <div class="row">
    <div class="col-2 login-header-spacer"></div>
    <div class="col-2 login-icon">
      <img class="login-image" src="{{currentStage.stageIcon}}" alt="Login Icon">
    </div>
    <div class="col-6 login-heading">
      <div class="login-heading-text-container">
        <div class="login-heading-text-header">{{currentStage.stageHeading}}</div>
        <div class="login-heading-text-subheader">
          {{currentStage.stageSubHeading}}
          @if (loginStage === LoginStage.OTPAuthentication) {
            <span> {{authMethodResponse.authConfig.mobileNumber}} </span>
          }
        </div>
      </div>
    </div>
    <div class="col-2 login-header-spacer"></div>
  </div>

  <div class="gap20"></div>
  <form [formGroup]="loginForm">
    @switch (loginStage) {
      @case (LoginStage.CanvasserCode) {
        <div class="row justify-content-center">
          <div class="col-4 login-field-col">
            <label class="col-form-label" for="canvasser_code">Canvasser Code:</label>
          </div>
          <div class="col-4 login-field-col">
            <input
              type="text"
              class="form-control"
              formControlName="canvasser_code"
              id="canvasser_code"
              maxlength="20"
              inputAutoFocus
              (keydown)="preventSpace($event)"
              placeholder=""/>
            @if (loginForm.get('canvasser_code')?.touched &&
                loginForm.get('canvasser_code')?.hasError('required')) {
              <small>Canvasser Code is required.</small>
            }
            @if (loginForm.get('canvasser_code')?.touched &&
                loginForm.get('canvasser_code')?.hasError('pattern')) {
              <small>Invalid Canvasser Code.</small>
            }
          </div>
        </div>
      }
      @case (LoginStage.OTPAuthentication) {
        <div class="row justify-content-center">
          <div class="col-4">
            <label class="col-form-label" for="otp">OTP:</label>
          </div>
          <div class="col-4">
            <input
              type="text"
              class="form-control"
              formControlName="otp"
              inputAutoFocus
              (keypress)="isNumber($event)"
              id="otp"
              placeholder=""
              maxlength="4"
              minlength="4"
              inputmode="numeric" />
            @if (loginForm.get('otp')?.touched && loginForm.get('otp')?.invalid && !otpInvalid) {
              <small>OTP pin field is mandatory</small>
            }
            @if (otpInvalid) {
              <small>{{otpResponseMessage}}</small>
            }
          </div>
        </div>
      }
      @case (LoginStage.RetailerSelection) {
        <div class="row justify-content-center">
          <div class="col-8 login-select-col">
            <p-select
              [options]="this.retailers"
              [(ngModel)]="selectedRetailer"
              formControlName="retailer"
              inputAutoFocus
              optionLabel="companyName"
              [filter]="true"
              filterBy="companyName,companyCode"
              [showClear]="true"
              placeholder="Select a Retailer"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38">
              <ng-template pTemplate="selectedItem">
                @if (selectedRetailer) {
                  <div>{{selectedRetailer.companyName}} - {{selectedRetailer.companyCode}}</div>
                }
              </ng-template>
              <ng-template let-retailer pTemplate="item">
                <div>{{retailer?.companyName}} - {{retailer?.companyCode}}</div>
              </ng-template>
            </p-select>
          </div>
        </div>
      }
      @case (LoginStage.StoreSelection) {
        <div class="row justify-content-center">
          <div class="col-8 login-select-col">
            <p-select
              [options]="canvasserStores"
              [(ngModel)]="canvasserStore"
              inputAutoFocus
              formControlName="store"
              optionLabel="storeName"
              [filter]="true"
              filterBy="storeName,storeNo"
              [showClear]="true"
              placeholder="Select a Store"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38">
              <ng-template pTemplate="selectedItem">
                @if (canvasserStore) {
                  <div class="country-item country-item-value">
                    <div>{{canvasserStore.storeName}} {{"(" + canvasserStore.storeNo + ")"}}</div>
                  </div>
                }
              </ng-template>
              <ng-template let-store pTemplate="item">
                <div class="country-item">
                  <div>{{store?.storeName + " (" + store?.storeNo + ")"}}</div>
                </div>
              </ng-template>
            </p-select>
          </div>
        </div>
      }
    }

    <div class="gap20"></div>

    @switch (loginStage) {
      @case (LoginStage.CanvasserCode) {
        <div class="row justify-content-center">
          <div class="col-4 login-btn-col">
            <button
              type="button"
              class="form-control login-btn"
              type="submit"
              [disabled]="loginForm.get('canvasser_code')?.invalid"
              (click)="submitCanvasserCode()">
              Send OTP
            </button>
          </div>
        </div>
      }
      @case (LoginStage.OTPAuthentication) {
        <div class="row justify-content-center">
          <div class="col-4 login-btn-col login-btn-col--cancel">
            <button type="button" class="form-control login-btn" (click)="back()">Cancel</button>
          </div>
          <div class="col-4 login-btn-col login-btn-col--primary">
            <button type="button" class="form-control login-btn" type="submit"
              [disabled]="this.loginForm.value.otp == undefined || this.loginForm.value.otp.length != 4"
              (click)="verifyOtp()">Authenticate</button>
          </div>
        </div>
      }
      @case (LoginStage.RetailerSelection) {
        <div class="row justify-content-center">
          <div class="col-8 login-btn-wrapper">
            <div class="row justify-content-center">
              @let colClass = cameFromAppSelection ? 'col-4' : 'col-6';

              <div [ngClass]="[colClass, 'login-btn-col', 'login-btn-col--cancel']">
                <button
                  type="button"
                  class="form-control login-btn"
                  (click)="back()">
                  Cancel
                </button>
              </div>

              @if (cameFromAppSelection) {
                <div [ngClass]="[colClass, 'login-btn-col', 'login-btn-col--back']">
                  <button
                    type="button"
                    class="form-control login-btn"
                    (click)="backToAppSelection()">
                    Back
                  </button>
                </div>
              }

              <div [ngClass]="[colClass, 'login-btn-col', 'login-btn-col--primary']">
                <button
                  type="button"
                  class="form-control login-btn"
                  [disabled]="!selectedRetailer"
                  (click)="selectRetailer()">
                    Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      @case (LoginStage.StoreSelection) {
        <div class="row justify-content-center">
          <div class="col-8 login-btn-wrapper">
            <div class="row justify-content-center">
              @let colClass = redirectUser.navbarUser.isUniversalCanvasser ? 'col-4' : 'col-6';

              <div [ngClass]="[colClass, 'login-btn-col', 'login-btn-col--cancel']">
                <button
                  type="button"
                  class="form-control login-btn"
                  (click)="back()">
                  Cancel
                </button>
              </div>

              @if (redirectUser.navbarUser.isUniversalCanvasser) {
                <div [ngClass]="[colClass, 'login-btn-col', 'login-btn-col--back']">
                  <button
                    type="button"
                    class="form-control login-btn"
                    (click)="backToRetailerSelection()">
                    Back
                  </button>
                </div>
              }

              <div [ngClass]="[colClass, 'login-btn-col', 'login-btn-col--primary']">
                <button
                  type="submit"
                  class="form-control login-btn"
                  [disabled]="!canvasserStore"
                  (click)="login()">
                    Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    }

  </form>




  <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':modalDisplay}">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title margin_center">Are you sure you want to cancel?</h4>
        </div>
        <div class="modal-body">
          <div class="row justify-content-center">
            <div class="gap20"></div>
            <div class="col-4 login-btn-col">
              <button 
                  type="button" 
                  class="form-control cancel-proceed-btn" 
                  (click)="cancelOnLogin()">
                Yes
              </button>
            </div>
            <div class="col-4 login-btn-col">
              <button 
                  type="button" 
                  class="form-control cancel-back-btn" 
                  (click)="closeCancelModal()">
                No
              </button>
            </div>
            <div class="gap20"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay"></div>
  </div>

</div>